import React, { PropTypes, PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { Small, Large } from '../../../../../../src/components/common/text';
import Text , { H3, H1} from '@dbk/ui-text';
import Button from '../../../../../../src/components/common/button';
import { GenerateOTPIcon } from '../../../../../../src/components/common/icons';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import envConfig from '../../../../../../../dbk-web/db-env-build';
import { EBANKINGWEBLUX } from '../../../../../../../dbk-web/src/constants';

class VascoNotActivated extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };

    this.onLogOut = this.onLogOut.bind(this);
  }

  returnDaysLabel(numberOfDays) {
    const { i18n: { messages } } = this.props;
    if (numberOfDays == 1) {
      return messages['app.auth.vasco.activation.etb.day'];
    }
    return messages['app.auth.vasco.activation.etb.days'];
  }

  returnDaysMessage(numberOFdays) {
    const { i18n: { messages } } = this.props;
    if (numberOFdays > 0) {
      return messages['app.auth.vasco.activation.etb.withinGrace'];
    }
    return messages['app.auth.vasco.activation.etb.outsideGrace'];
  }

  async onLogOut() {
    this.setState({ isLoading: true });
    await this.props.logout();
    this.setState({ isLoading: false });
  }


  render() {
    let { i18n: { messages }, vascoauthentication: { gracePeriod, isNTB } } = this.props;
    const { isLoading } = this.state;
    return (
      <div className="scene">
        <div className="row vasco">
          <div className="columns small-12 paddingClass">
            <div className="module">
              {!isLoading && <div>
                <div>
                  <div className="pad-bottom-30 text-center large-centered medium-centered small-centered title-container">
                    <div className="pad-left-2 text-center large-centered medium-centered">
                      <Text secondary>{messages['app.vasco.activation.heading']}</Text><br />
                      <Text secondary>{messages['app.vasco.activation.heading2']}</Text>
                    </div>
                  </div>
                  <div>
                    <div className="large-12 pad-bottom-30 instructions-block instruction-steps">
                      <div className="pad-bottom-30 text-center">

                        <Text secondary>{messages['app.vasco.activation.instruction.title']}</Text>

                      </div>
                      <div className="large-centered large-12 medium-12 medium-centered">
                        <div className="medium-4 columns">
                          <span className="big-letter pad-right-4">1</span>
                          <span className="text-left">{messages['app.vasco.activation.instruction.step1']}</span>
                        </div>
                        <div className="medium-4 columns text-border-left">
                          <span className="big-letter pad-right-4">2</span>
                          <span className="text-left vascoActivationStep2">{messages['app.vasco.activation.instruction.step2']}</span>
                        </div>
                        <div className="medium-4 columns text-border-left">
                          <span className="big-letter pad-right-4">3</span>
                          <span className="text-left vascoActivationStep3">{messages['app.vasco.activation.instruction.step3']}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {!this.props.vascoauthentication.isNTB && envConfig.envConfig !== EBANKINGWEBLUX && <div className="row gracePeriod pad-top-30 pad-left-30 pad-right-30 margin-top-30">
                    <div className="small-2 large-1 columns days-div standard-bg">
                      <span className="big-letter-graceperiod">{gracePeriod}</span>
                      <Small>{this.returnDaysLabel(gracePeriod)}</Small>
                    </div>
                    <div className="small-8 medium-8 large-9 columns message-div standard-bg" >
                      <div className="message-text">
                        <Text secondary>{this.returnDaysMessage(gracePeriod)}</Text>
                      </div>
                    </div>
                  </div>}
                </div>
                {envConfig.envConfig !== EBANKINGWEBLUX &&
                <div>
                  <div className="row">
                    <div className="column small-centered small-12 medium-centered medium-12 large-centered large-12 pad-top-30 text-center">
                      <div className="button-container-single">
                        {(gracePeriod > 0 && !this.props.vascoauthentication.isNTB) &&
                          <Button id="btn_vascoSkip_vascoNotActivated"
                            title={messages['app.vasco.graceperiod.skip']}
                            inline
                            size="header3"
                            onPress={this.props.onHideVascoNotActivated}
                          />
                        }
                      </div>
                    </div>
                  </div>

                </div>}
              </div>
              }
              {isLoading &&  <LoadingCircle />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    logout: { $call: 'auth.logout' },
    onHideVascoNotActivated: { $call: 'vascoauthenticaiton.hideNotActivatedModal' },
    vascoauthentication: {
      otpStatus: true,
      gracePeriod: true,
      isNTB: true,
    },
    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
    i18n: {
      messages: true,
    },
    auth: {
      logOut: { $call: 'logout' },
    },
  },
})(VascoNotActivated);